import AfterCheckoutError from "../../base/ts/events/Checkout/AfterCheckoutError";
import CheckoutCustomizationEventBus from "../../base/ts/EventBus/CheckoutCustomizationEventBus";

export default class PledgClient {
    pledg: any;
    hiddenButton: any;

    constructor() {
        this.hiddenButton = document.createElement("button");
        this.hiddenButton.id = "pledg-button";
        this.hiddenButton.style.cssText = "display:none;";
        document.body.appendChild(this.hiddenButton);
    }

    init(orderDetails: object, redirect: string) {
        // If Pledg hasn't been initialized yet
        if (this.pledg === undefined || this.pledg === null) {
            // @ts-ignore
            this.pledg = new Pledg(this.hiddenButton, {
                ...orderDetails,

                paymentNotificationUrl: window.ajax_object.daalder_api_url.replace(/\/*$/, "") + "/v2/webhooks/payment",
                onSuccess: function (result) {
                    window.location.href = redirect;
                },
                onError: function (error) {
                    CheckoutCustomizationEventBus.emit("afterCheckoutError", new AfterCheckoutError({}));
                },
                onCheckValidity({ isValid, error }) {
                    if (error?.type === "invalid_request_error") {
                        CheckoutCustomizationEventBus.emit(
                            "afterCheckoutError",
                            new AfterCheckoutError({}, error.message),
                        );
                    }
                },
            });
        } else {
            // If Pledge already has been initialized, update the instance
            this.pledg.configure({
                ...orderDetails,
            });
        }
    }

    open() {
        setTimeout(() => {
            this.hiddenButton.click();
        }, 2000);
    }
}
